import PropTypes from 'prop-types';
import React from 'react';

import AssayDataNotePart from './assay-group/AssayDataNotePart';

/**
 * Simple component for cases where assay data doesn't exist - missing permissions, archived, etc.
 */
export default function EmptyAssayDataMessage(props: EmptyAssayDataMessageProps): JSX.Element {
  return (
    <AssayDataNotePart includeWrapper={true} indentation={props.indentation}>
      <div className="resultsAttachment-header">{props.title}</div>
      {props.children}
    </AssayDataNotePart>
  );
}
interface EmptyAssayDataMessageProps {
  children: React.ReactNode;
  indentation: number;
  title: string;
}
EmptyAssayDataMessage.propTypes = {
  children: PropTypes.node.isRequired,
  indentation: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};
